import Head from 'next/head'

export type JsonLdProps = {
  type: string
  structuredData: Record<string, unknown>
}

const JsonLd = ({ type, structuredData }: JsonLdProps) => (
  <Head>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': type,
          ...structuredData,
        }),
      }}
      key={`jsonld-${type}`}
    />
  </Head>
)

export default JsonLd
